const fallbackFonts = `-apple-system,
BlinkMacSystemFont,
"Segoe UI",
"Roboto",
"Oxygen",
"Ubuntu",
"Cantarell",
"Fira Sans",
"Droid Sans",
"Helvetica Neue",
sans-serif`;
export { fallbackFonts };
//# sourceMappingURL=fallbackFonts.js.map
